import React from 'react'
import {connect} from 'react-redux'
import {
    Button,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    InputNumber,
    message,
    Row,
    Select,
    Spin,
    Typography,
    Upload
} from 'antd'
import {UploadOutlined} from '@ant-design/icons'

import artEducationSmall from '../../asset/image/Art_Education-small.jpeg'
import commissionSmall from '../../asset/image/Commission-small.jpeg'
import immersiveExhibitionEventSmall from '../../asset/image/Immersive_Exhibition_Event_small.png'
import internationalArtworkSellingSmall from '../../asset/image/International_artwork_selling-small.jpeg'
import productSmall from '../../asset/image/Product-small.jpeg'
import spaceDesignSmall from '../../asset/image/Space_Design-small.jpeg'
import undecidedSmall from '../../asset/image/Undecided-small.jpeg'

import {uploadAvatar, uploadResume} from '../../api/amazonS3'
import {getArtist, getArtistProfile, patchArtist, patchArtistProfile} from '../../api/artists'
import {getArtistNames} from '../../api/artistNames'

import FormButton from '../../component/base/FormButton'
import ArtStyleCheckbox from '../../component/piece/ArtStyleCheckbox'
import MediumCheckbox from '../../component/piece/MediumCheckbox'
import {getFileNameByUrl} from '../../app/util'
import {IN_PRODUCT} from '../../config/product'
import HttpError from "../../component/base/HttpError";

const {Option} = Select
const {Title, Text} = Typography

@connect((state) => ({
    userId: state.user.info.userId,
    artistId: state.user.info.artistId,
    email: state.user.info.email
}))
class Profile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            imageLoading: false,
            loading: false,
            pseudonymInputVisible: true,
            base_url: IN_PRODUCT ? 'https://revart.co' : 'http://localhost:8000',
            artist_id: 0,
            artist_name: '',
            isP1ModalVisible: false,
            isP2ModalVisible: false,
            isP3ModalVisible: false
        }
        this.formRef = React.createRef()
    }

    componentDidMount() {
        if (!this.props.userId || !this.props.artistId) return

        this.setState({
            loading: true
        })

        Promise.all([getArtist(this.props.userId), getArtistProfile(this.props.artistId),
            getArtistNames(this.props.artistId)]).then(async (response) => {
            const artist = response[0].data
            const artistProfile = response[1].data
            const artistNames = response[2].data
            if (artist.art_style && artist.art_style.indexOf("'") !== -1) {
                artist.art_style = JSON.parse(artist.art_style.replace(/'/g, '"')).join(';')
            }
            this.initializeFieldsValue(this.props.email, artist, artistNames, artistProfile)
            this.setState({
                artist_name: this.getArtistName(artistNames.first_name, artistNames.middle_name,
                    artistNames.last_name, artistNames.nick_name),
            })
        }).catch((error) => {
            HttpError(error)
        }).finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    initializeFieldsValue = (email, artist, artistNames, artistProfile) => {
        if (this.formRef?.current == null) return
        let sanity_resume_url = (url) => {
            if (url) {
                if (url.startsWith('/home/ubuntu')) {
                    let urls = url.split('/')
                    url = 'https://revart.co/media/' + urls[urls.length - 1]
                }
                if (url === 'None') {
                    return null
                }
            }
            return url
        }

        this.formRef.current.setFieldsValue({
            email: email,
            artistId: artistNames.artist,
            firstName: artistNames.first_name,
            middleName: artistNames.middle_name,
            lastName: artistNames.last_name,
            nickName: artistNames.nick_name,

            resume: sanity_resume_url(artist.resume_url)
                ? [
                    {
                        name: getFileNameByUrl(artist.resume_url),
                        status: 'done',
                        url: sanity_resume_url(artist.resume_url)
                    }
                ]
                : null,
            medium: artist.medium?.split(';'),
            nameSelect: artist.name_select,
            pseudonym: artist.pseudonym,
            yearOfBirth: artist.year_of_birth,
            street: artist.street,
            zipCode: artist.zipcode,
            city: artist.city,
            state: artist.state,
            country: artist.country,
            phone: artist.phone,
            artStyle: artist.art_style?.split(';'),
            yearsInTheCareer: artist.years_in_career,
            artStatement: artist.art_statement,
            personalWebsite: artist.social_website,
            Facebook: artist.social_facebook,
            LinkedIn: artist.social_linkedin,
            Instagram: artist.social_instagram,
            collaboration: artist.collaboration?.split(';'),

            // artist profile
            avatar: artistProfile.avatar
                ? [
                    {
                        name: getFileNameByUrl(artistProfile.avatar),
                        status: 'done',
                        url: artistProfile.avatar,
                        thumbUrl: artistProfile.avatar
                    }
                ]
                : null,

            profile_image: artistProfile.profile_image
                ? [
                    {
                        name: getFileNameByUrl(artistProfile.profile_image),
                        status: 'done',
                        url: artistProfile.profile_image,
                        thumbUrl: artistProfile.profile_image
                    }
                ]
                : null,

            job_title: artistProfile.job_title
        })
    }

    handleFormValuesChange = (changedValues, allValues) => {

    }

    onFinish = (values) => {
        const {job_title} = values
        const {
            resume,
            medium,
            collaboration,
            artStatement,
            yearOfBirth,
            country,
            phone,
            artStyle,
            yearsInTheCareer,
            street,
            zipCode,
            city,
            state,
            personalWebsite,
            Facebook,
            LinkedIn,
            Instagram
        } = values
        const artistParam = {
            medium: medium.join(';'),
            collaboration: collaboration.join(';'),
            year_of_birth: yearOfBirth,
            street: street,
            zipcode: zipCode,
            city: city,
            state: state,
            country: country,
            phone: phone,
            art_style: artStyle.join(';'),
            years_in_career: yearsInTheCareer,
            art_statement: artStatement,
            social_website: personalWebsite === '' ? null : personalWebsite,
            social_facebook: Facebook === '' ? null : Facebook,
            social_linkedin: LinkedIn === '' ? null : LinkedIn,
            social_instagram: Instagram === '' ? null : Instagram
        }
        const artistProfileParam = {
            job_title: job_title,
            city: city,
            country: country
        }
        if (resume) {
            artistParam.resume_url = resume[0].response !== undefined ? resume[0].response.url : resume[0].url
        }
        this.setState({loading: true})
        Promise.all([
            patchArtist(this.props.userId, artistParam),
            patchArtistProfile(this.props.artistId, artistProfileParam)
        ])
            .then((response) => {
                message.success('Update successfully').then(() => {
                })
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({loading: false})
        })
    }

    customImageRequest = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        uploadAvatar(this.props.email, file, onSuccess, onError, onProgress)
    }

    getArtistPageUrl = (id, name) => {
        if (!name || !id) return ''
        let f = name
        f = f.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')
        f = f.replaceAll('’', '').replaceAll('?', '').replaceAll('!', '')
        f = f.replaceAll("'", '').replaceAll('.', '').replaceAll(':', '')
        f = f.replaceAll('&', 'and')

        return f + '_' + id
    }

    getArtistName = (first, middle, last, pseudonym) => {
        if (pseudonym && pseudonym?.toString() !== '') {
            return pseudonym
        }
        if (middle && middle?.toString() !== '') {
            return first + ' ' + middle + ' ' + last
        }
        return first + ' ' + last
    }

    customRequest = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        uploadResume(this.props.email, file, onSuccess, onError, onProgress)
    }

    render() {
        return (
            <Spin size='large' spinning={this.state.loading}>
                <div className='site-layout-background'>
                    <Form
                        labelCol={{span: 4}}
                        wrapperCol={{span: 16}}
                        style={{paddingLeft: '4%', paddingRight: '4%'}}
                        colon={false}
                        ref={this.formRef}
                        onValuesChange={this.handleFormValuesChange}
                        onFinish={this.onFinish}
                    >
                        <Row justify='space-around' gutter={{xs: 8, sm: 16, md: 24}} wrap={true}>
                            <Col span={24}>
                                <Title>Personal Information</Title>
                                <Form.Item
                                    name='yearOfBirth'
                                    label='Year of birth'
                                    rules={[
                                        {
                                            required: false
                                        }
                                    ]}
                                >
                                    <InputNumber/>
                                </Form.Item>
                                <Form.Item
                                    name='street'
                                    label='Street'
                                    rules={[
                                        {
                                            required: false,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='zipCode'
                                    label='Zip code'
                                    rules={[
                                        {
                                            required: false,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='city'
                                    label='City'
                                    rules={[
                                        {
                                            required: false,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='state'
                                    label='State'
                                    rules={[
                                        {
                                            required: false,
                                            type: 'enum',
                                            enum: [
                                                'Not',
                                                'AK',
                                                'AL',
                                                'AR',
                                                'AS',
                                                'AZ',
                                                'CA',
                                                'CO',
                                                'CT',
                                                'DC',
                                                'DE',
                                                'FL',
                                                'GA',
                                                'GU',
                                                'HI',
                                                'IA',
                                                'ID',
                                                'IL',
                                                'IN',
                                                'KS',
                                                'KY',
                                                'LA',
                                                'MA',
                                                'MD',
                                                'ME',
                                                'MI',
                                                'MN',
                                                'MO',
                                                'MP',
                                                'MS',
                                                'MT',
                                                'NA',
                                                'NC',
                                                'ND',
                                                'NE',
                                                'NH',
                                                'NJ',
                                                'NM',
                                                'NV',
                                                'NY',
                                                'OH',
                                                'OK',
                                                'OR',
                                                'PA',
                                                'PR',
                                                'RI',
                                                'SC',
                                                'SD',
                                                'TN',
                                                'TX',
                                                'UT',
                                                'VA',
                                                'VI',
                                                'VT',
                                                'WA',
                                                'WI',
                                                'WV',
                                                'WY'
                                            ]
                                        }
                                    ]}
                                >
                                    <Select showSearch>
                                        <Option value='Not'>Not in the (US)</Option>
                                        <Option value='AK'>Alaska</Option>
                                        <Option value='AL'>Alabama</Option>
                                        <Option value='AR'>Arkansas</Option>
                                        <Option value='AS'>American Samoa</Option>
                                        <Option value='AZ'>Arizona</Option>
                                        <Option value='CA'>California</Option>
                                        <Option value='CO'>Colorado</Option>
                                        <Option value='CT'>Connecticut</Option>
                                        <Option value='DC'>District of Columbia</Option>
                                        <Option value='DE'>Delaware</Option>
                                        <Option value='FL'>Florida</Option>
                                        <Option value='GA'>Georgia</Option>
                                        <Option value='GU'>Guam</Option>
                                        <Option value='HI'>Hawaii</Option>
                                        <Option value='IA'>Iowa</Option>
                                        <Option value='ID'>Idaho</Option>
                                        <Option value='IL'>Illinois</Option>
                                        <Option value='IN'>Indiana</Option>
                                        <Option value='KS'>Kansas</Option>
                                        <Option value='KY'>Kentucky</Option>
                                        <Option value='LA'>Louisiana</Option>
                                        <Option value='MA'>Massachusetts</Option>
                                        <Option value='MD'>Maryland</Option>
                                        <Option value='ME'>Maine</Option>
                                        <Option value='MI'>Michigan</Option>
                                        <Option value='MN'>Minnesota</Option>
                                        <Option value='MO'>Missouri</Option>
                                        <Option value='MP'>Northern Mariana Islands</Option>
                                        <Option value='MS'>Mississippi</Option>
                                        <Option value='MT'>Montana</Option>
                                        <Option value='NA'>National</Option>
                                        <Option value='NC'>North Carolina</Option>
                                        <Option value='ND'>North Dakota</Option>
                                        <Option value='NE'>Nebraska</Option>
                                        <Option value='NH'>New Hampshire</Option>
                                        <Option value='NJ'>New Jersey</Option>
                                        <Option value='NM'>New Mexico</Option>
                                        <Option value='NV'>Nevada</Option>
                                        <Option value='NY'>New York</Option>
                                        <Option value='OH'>Ohio</Option>
                                        <Option value='OK'>Oklahoma</Option>
                                        <Option value='OR'>Oregon</Option>
                                        <Option value='PA'>Pennsylvania</Option>
                                        <Option value='PR'>Puerto Rico</Option>
                                        <Option value='RI'>Rhode Island</Option>
                                        <Option value='SC'>South Carolina</Option>
                                        <Option value='SD'>South Dakota</Option>
                                        <Option value='TN'>Tennessee</Option>
                                        <Option value='TX'>Texas</Option>
                                        <Option value='UT'>Utah</Option>
                                        <Option value='VA'>Virginia</Option>
                                        <Option value='VI'>Virgin Islands</Option>
                                        <Option value='VT'>Vermont</Option>
                                        <Option value='WA'>Washington</Option>
                                        <Option value='WI'>Wisconsin</Option>
                                        <Option value='WV'>West Virginia</Option>
                                        <Option value='WY'>Wyoming</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name='country'
                                    label='Country'
                                    rules={[
                                        {
                                            required: false,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='phone'
                                    label='Phone number'
                                    rules={[
                                        {
                                            required: false,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='job_title'
                                    label='Job title'
                                    rules={[
                                        {
                                            required: false,
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider></Divider>

                        <Row justify='space-around' gutter={{xs: 8, sm: 16, md: 24}} wrap={true}>
                            <Col span={24}>
                                <Title>Art Career</Title>
                                <Form.Item
                                    style={{marginTop: 24}}
                                    name='artStyle'
                                    label='Art style'
                                    rules={[
                                        {
                                            required: false
                                        }
                                    ]}
                                >
                                    <ArtStyleCheckbox/>
                                </Form.Item>
                                <Form.Item
                                    name='yearsInTheCareer'
                                    label='Years in career'
                                    rules={[
                                        {
                                            required: false
                                        }
                                    ]}
                                >
                                    <InputNumber/>
                                </Form.Item>
                                <Form.Item
                                    name='resume'
                                    label='Resume'
                                    valuePropName='fileList'
                                    getValueFromEvent={(e) => {
                                        if (Array.isArray(e)) {
                                            return e
                                        }
                                        return e && e.fileList
                                    }}
                                >
                                    <Upload listType='text' maxCount={1} customRequest={this.customRequest}>
                                        <Button icon={<UploadOutlined/>}>Click to upload</Button>
                                    </Upload>
                                </Form.Item>

                                <Form.Item
                                    name='medium'
                                    label='Medium'
                                    rules={[
                                        {
                                            required: false
                                        }
                                    ]}
                                >
                                    <MediumCheckbox/>
                                </Form.Item>
                                <Form.Item
                                    name='collaboration'
                                    label={
                                        <span>
                    Collaboration <br/> Preferences
                  </span>
                                    }
                                    rules={[
                                        {
                                            required: false
                                        }
                                    ]}
                                    style={{
                                        wordWrap: 'break-word',
                                        whiteSpace: 'pre-wrap'
                                    }}
                                >
                                    <Checkbox.Group>
                                        <Row justify='space-between' gutter={{xs: 8, sm: 16, md: 24}}
                                             style={{width: '100%'}}>
                                            <Col className='medium-picture'>
                                                <img src={artEducationSmall} alt='Painting'/>
                                                <Checkbox value='art-education'>Art Education</Checkbox>
                                            </Col>
                                            <Col className='medium-picture'>
                                                <img src={commissionSmall} alt='Drawing'/>
                                                <Checkbox value='commission'>Commission</Checkbox>
                                            </Col>
                                            <Col className='medium-picture'>
                                                <img src={immersiveExhibitionEventSmall} alt='Sculpture'/>
                                                <Checkbox value='immersive-exhibition-event'>Immersive Exhibition
                                                    Event</Checkbox>
                                            </Col>
                                            <Col className='medium-picture'>
                                                <img src={internationalArtworkSellingSmall} alt='Collage'/>
                                                <Checkbox value='international-artwork-selling'>International Artwork
                                                    Selling</Checkbox>
                                            </Col>
                                            <Col className='medium-picture'>
                                                <img src={productSmall} alt='Installation & Digital'/>
                                                <Checkbox value='product'>Product</Checkbox>
                                            </Col>
                                            <Col className='medium-picture'>
                                                <img src={spaceDesignSmall} alt='Mixed Media'/>
                                                <Checkbox value='space-design'>Space Design</Checkbox>
                                            </Col>
                                            <Col className='medium-picture'>
                                                <img src={undecidedSmall} alt='Mixed Media'/>
                                                <Checkbox value='undecided'>Undecided</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider></Divider>

                        <Row justify='space-around' gutter={{xs: 8, sm: 16, md: 24}} wrap={true}>
                            <Col span={24}>
                                <Title>Social Media Links</Title>
                                <Text type='secondary' style={{marginTop: 6}}>If you have any social media links, please
                                    share them with us.</Text>
                                <Form.Item
                                    style={{marginTop: 32}}
                                    label='Personal Website'
                                    name='personalWebsite'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 250,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label='Facebook'
                                    name='Facebook'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 250,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label='Instagram'
                                    name='Instagram'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 250,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label='Linkedln'
                                    name='LinkedIn'
                                    rules={[
                                        {
                                            type: 'string',
                                            max: 250,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <FormButton></FormButton>
                    </Form>
                </div>
            </Spin>
        )
    }
}

export default Profile
